<template>
  <v-row class="panel-section-header">
    <h4>{{ $t('components.panelConfiguration.truckDimensions') }}</h4>
  </v-row>
  <v-row>
    <v-col cols="12" sm="3">
      <v-text-field :model-value="truckLength" @update:model-value="val => $emit('update:truckLength', val)"
                    :label="$t('functionalities.panelEstimator.truckLength')" debounce="300" type="number" min="0" />
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field :model-value="truckWidth" @update:model-value="val => $emit('update:truckWidth', val)"
                    :label="$t('functionalities.panelEstimator.truckWidth')" type="number" min="0" />
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field :model-value="truckHeight" @update:model-value="val => $emit('update:truckHeight', val)"
                    :label="$t('functionalities.panelEstimator.truckHeight')" type="number" min="0" />
    </v-col>
    <v-col cols="12" sm="3">
      <v-text-field :model-value="spacerThickness" @update:model-value="val => $emit('update:spacerThickness', val)"
                    :label="$t('components.panelConfiguration.spacerThickness')" type="number" min="0" step="0.01" />
    </v-col>
  </v-row>
</template>

<script setup>


defineProps({
  truckLength: [Number, String],
  truckWidth: [Number, String],
  truckHeight: [Number, String],
  spacerThickness: [Number, String]
});
defineEmits([
  'update:truckLength',
  'update:truckWidth',
  'update:truckHeight',
  'update:spacerThickness'
]);
</script>

<style scoped>
@import '@/assets/styles/components/panelCountEstimator/TruckDimensions.css';
</style>